import { Box, Grid } from "@material-ui/core";
import { AdhocAgreement } from "integrity-owls-logic/src/models";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { adhocAgreementsService } from "../../../services/AdhocAgreementsService";
import PageHeader from "../../shared/Header";
import { AdhocAgreementsErrorBanner } from "../ErrorBanner";
import { AdhocAgreementForm } from "../shared/Form";
export const EditAdhocAgreementPage: React.FC = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { id } = useParams<{ id: string }>();
  const [agreement, setAgreement] = useState<AdhocAgreement | undefined>(
    undefined
  );

  useEffect(() => {
    const fetchAgreement = async () => {
      const agreement = await adhocAgreementsService.getAdhocAgreement({
        id: parseInt(id)
      });
      console.log("agreement", agreement);
      setAgreement(agreement);
    };
    fetchAgreement();
  }, [id]);

  const handleSubmit = useCallback(async (vals: any) => {
    setLoading(true);
    try {
      const updatedAgreement = await adhocAgreementsService.updateAdhocAgreement(
        vals
      );
      console.log("updatedAgreement", updatedAgreement);
      history.push(`/adhoc-agreements/${updatedAgreement.id}`);
    } catch (err) {
      console.error("error", err);
      const messages = (err as any).errors
        .map((e: any) => e.message)
        .join(", ");
      console.log("messages", messages);
      setError(messages);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <Box>
      <PageHeader title="Edit Adhoc Agreement" />
      <AdhocAgreementsErrorBanner
        error={error}
        handleBannerDismiss={() => setError("")}
        showBanner={!!error}
      />

      <Grid container>
        <AdhocAgreementForm
          agreement={agreement}
          loading={loading}
          onSubmit={handleSubmit}
        />
      </Grid>
    </Box>
  );
};

export default EditAdhocAgreementPage;
